import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  Button,
  Table,
} from 'reactstrap';

import BulkVersioningFileListItem from './FileListItem';

import { slugify } from '../../helpers';

import ErrorBoundary from '../ErrorBoundary';

const BulkVersioningFileList = ({ uploader, files, fileExists }) => {
  const intl = useIntl();

  const handleTriggerFolderInput = () => {
    const button = document.getElementById('bulk-versioning-folder-input');
    if (button) {
      button.click();
    }
  };

  return (
    <ErrorBoundary>
      {files.length > 0 ? (
        <Table bordered responsive className="bulk-versioning-file-list">
          <tbody>
            {files.map(file => (
              <BulkVersioningFileListItem
                uploader={uploader}
                key={slugify(file.hdcFullPath)}
                file={file}
                fileExists={fileExists(file.hdcFullPath)}
              />
            ))}
          </tbody>
        </Table>
      ) : (
        <div className="no-files">
          <Button onClick={handleTriggerFolderInput} size="lg">
            <i className="fa-regular fa-folder" />
            {intl.formatMessage({ defaultMessage: 'Select folder' })}
          </Button>
        </div>
      )}
    </ErrorBoundary>
  );
};

BulkVersioningFileList.propTypes = {
  uploader: PropTypes.object.isRequired,
  files: PropTypes.array.isRequired,
  fileExists: PropTypes.func.isRequired,
};

export default BulkVersioningFileList;
